import { ref, watch, watchEffect } from 'vue';
import type { Ref } from 'vue';

export interface UseMobileSwitchOptions {
  isLeftOpen: Ref<boolean>;
  isRightOpen: Ref<boolean>;
}

export function useMobileSwitch(options: UseMobileSwitchOptions) {
  const { isLeftOpen, isRightOpen } = options;

  // Mobile switcher state
  const mobileSwitchValue = ref('left');

  const updateMobileSwitchValue = () => {
    // Determine initial mobile switch value based on current sidebar states
    if (isLeftOpen.value) {
      mobileSwitchValue.value = 'left';
    } else if (isRightOpen.value) {
      mobileSwitchValue.value = 'right';
    } else {
      mobileSwitchValue.value = 'center';
    }
  }

  updateMobileSwitchValue();

  // Watch for mobile switch value changes to update sidebar visibility
  watch(mobileSwitchValue, () => {
    switch (mobileSwitchValue.value) {
      case 'left':
        isLeftOpen.value = true;
        isRightOpen.value = false;
        break;
      case 'right':
        isLeftOpen.value = false;
        isRightOpen.value = true;
        break;
      default:
        isLeftOpen.value = false;
        isRightOpen.value = false;
        break;
    }
  });

  return {
    mobileSwitchValue
  };
}
